/**
 * @generated SignedSource<<a51eba3b3771bb66da74b477d73115fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAddToCartButton_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "PdpSharedAddToCartButton_user";
};
export type PdpSharedAddToCartButton_user$key = {
  readonly " $data"?: PdpSharedAddToCartButton_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAddToCartButton_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAddToCartButton_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "46a4c224140e6c74eae9cdc39e332586";

export default node;
